<app-header></app-header>
<div class="iframe" *ngIf="url">
    <!-- <iframe src="https://designer.videosity.net/" title="description"></iframe> -->
    <object [data]="url" width="100%" height="700" type="text/html">Please wait..</object>

</div>
